var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpark = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10.2,
  cy: 10.2,
  r: 7.2,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M10.2 2.2v2m0 12v2m-8-8h2m12 0h2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "m15.6 15.6 5.8 5.8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2 5.4c.9 2.1 2.7 3.5 4.8 4.4-2.1.9-3.9 2.3-4.8 4.4-.9-2.1-2.7-3.5-4.8-4.4 2.1-.9 3.9-2.3 4.8-4.4"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpark);
export default ForwardRef;